import { InjectionToken } from '@angular/core'

import { Observable } from 'rxjs'

import {
  NewOnPremOrganizationPayload,
  NewOrganizationPayload,
  NewOrganizationResponse,
} from './auth.types'

export const FX_ORGANIZATION_CODE_TOKEN = new InjectionToken<string>('FX_ORGANIZATION_CODE_TOKEN')
// cookie constant
export const FX_ORGANIZATION_CODE_COOKIE = 'FX-ORGANIZATION-CODE'
// host header
export const FX_CLIENT_HOST = 'Fx-Client-Host'
// query param constant
export const FX_ORGANIZATION_CODE = 'organizationCode'
// public endpoints the app initializer calls before the login sequence checks the stored token
export const ENVIRONMENT_DEFINITION_PATH = 'org/api/env'
export const ORGANIZATION_DISCOVERY_PATH = 'org/api/org/code'
// sign-in request parameter telling Keycloak the request comes from the designer, so its pages are unbranded
export const FX_SIGN_IN_SOURCE = 'source'
export const FX_SIGN_IN_SOURCE_DESIGNER = 'designer'

export abstract class RegistrationApi {
  readonly registerNewOrganization: (
    payload: NewOrganizationPayload | NewOnPremOrganizationPayload
  ) => Observable<NewOrganizationResponse>
}

// registration from support
export const REGISTER_API = new InjectionToken<RegistrationApi>('REGISTER_API')
